<h3>Report Admin</h3>
<DataGridView DataUrl="/Backend/Api/V2/ReportAdmin/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="bezeichnung" header="Bezeichnung" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Report">
        <ng-template #staticContent>
          <report-admin-edit [Report]="row"></report-admin-edit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header >
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Report">
        <ng-template #staticContent>
          <report-admin-edit></report-admin-edit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
